import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { Home } from '@/screens/Home';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function Main() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="freight brokerage, freight technology, freight software, LTL, FTL, managed transporation, shipper tech, carrier software, "
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        canonical="https://loadsmart.com/"
        title="Loadsmart | AI-Native TMS Logistics Platform, TMS & Dock Scheduling"
        openGraph={{
          url: 'https://loadsmart.com/',
        }}
      />
      <JsonLd data={Organization} />
      <Home />
    </>
  );
}
